import { Route, Routes } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import Header from "@components/students/header";
import Home from "@pages/students/home";
import Courses from "@pages/students/courses";
import { MenuPanel } from "@components/students/menu-panel";

const AuthStudentRoutes: React.FC = () => {
  const [menuDisplay, setMenuDisplay] = useState<boolean>(false);

  const resizeHandler = useCallback(() => {
    const clientWidth = document.documentElement.clientWidth;

    if (clientWidth > 1024 && menuDisplay) {
      setMenuDisplay(false);
    }
  }, [menuDisplay]);

  // LISTENER FOR CLOSING MENU PANEL, WHEN CLIENT WITH > 1024 && MENU PANEL IS OPEN
  useEffect(() => {
    window.addEventListener("resize", resizeHandler);

    return () => window.removeEventListener("resize", resizeHandler);
  }, [resizeHandler]);

  return (
    <>
      <Header
        menuDisplay={menuDisplay}
        onBurgerClick={() => setMenuDisplay(!menuDisplay)}
      />
      <div className={`content-wrapper ${menuDisplay ? "with-menu" : ""}`}>
        <MenuPanel onItemClick={() => setMenuDisplay(false)} />
        <Routes>
          <Route path="/" Component={Home} />
          <Route path="/course/*" Component={Courses} />
        </Routes>
      </div>
    </>
  );
};

export default AuthStudentRoutes;
